// import React, { useEffect, useState, useRef } from "react";
// import ReactDOM from "react-dom";
// import { useNavigate } from "react-router-dom";
// import { io } from "socket.io-client";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import AP_AUTOConstantsList from "../../common/AP_AUTOConstants";
// import ItemService from "../../services/supplier_appCommonService";

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://127.0.0.1:9001";
// const NotificationToast = ({ toast, onClose }) => {
//   useEffect(() => {
//     const timer = setTimeout(() => onClose(toast.id), 5000);
//     return () => clearTimeout(timer);
//   }, [toast.id, onClose]);

//   return (
//     <div
//       style={{
//         background: "#fff",
//         border: "1px solid #e0e0e0",
//         borderLeft: "4px solid #0d6efd",
//         borderRadius: "8px",
//         boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
//         padding: "14px 16px",
//         minWidth: "300px",
//         maxWidth: "360px",
//         display: "flex",
//         alignItems: "flex-start",
//         gap: "12px",
//         animation: "toastSlideIn 0.35s ease",
//         pointerEvents: "auto",
//       }}
//     >
//       {/* Icon */}
//       <div
//         style={{
//           width: "40px",
//           height: "40px",
//           borderRadius: "50%",
//           background: "#f1f5ff",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexShrink: 0,
//           fontSize: "18px",
//         }}
//       >
//         <i
//           className={`bi ${toast.icon || "bi-bell-fill"} ${
//             toast.iconColor || "text-primary"
//           }`}
//         ></i>
//       </div>

//       {/* Text */}
//       <div style={{ flex: 1, minWidth: 0 }}>
//         {/* "X of Y unread" badge — only for login-batch toasts */}
//         {toast.isLoginBatch && toast.batchTotal > 1 && (
//           <div
//             style={{
//               fontSize: "10px",
//               color: "#fff",
//               background: "#0d6efd",
//               borderRadius: "4px",
//               padding: "1px 6px",
//               display: "inline-block",
//               marginBottom: "5px",
//               fontWeight: 600,
//             }}
//           >
//             {toast.batchIndex + 1} of {toast.batchTotal} unread
//           </div>
//         )}
//         <div
//           style={{
//             fontWeight: 700,
//             fontSize: "13px",
//             color: "#1a1a2e",
//             marginBottom: "3px",
//           }}
//         >
//           {toast.title}
//         </div>
//         <div
//           style={{
//             fontSize: "12px",
//             color: "#555",
//             marginBottom: "5px",
//             wordBreak: "break-word",
//           }}
//         >
//           {toast.message}
//         </div>
//         <div style={{ fontSize: "11px", color: "#aaa" }}>
//           {toast.createdAt
//             ? new Date(toast.createdAt).toLocaleTimeString()
//             : "Just now"}
//         </div>
//       </div>

//       {/* Close button */}
//       <button
//         onClick={() => onClose(toast.id)}
//         style={{
//           background: "none",
//           border: "none",
//           color: "#aaa",
//           fontSize: "18px",
//           cursor: "pointer",
//           padding: 0,
//           lineHeight: 1,
//           flexShrink: 0,
//         }}
//       >
//         <i className="bi bi-x"></i>
//       </button>
//     </div>
//   );
// };
// const ToastContainer = ({ toasts, onClose }) => {
//   if (toasts.length === 0) return null;

//   return ReactDOM.createPortal(
//     <>
//       <style>{`
//         @keyframes toastSlideIn {
//           from { opacity: 0; transform: translateX(80px); }
//           to   { opacity: 1; transform: translateX(0); }
//         }
//       `}</style>
//       <div
//         style={{
//           position: "fixed",
//           top: "80px",
//           right: "24px",
//           zIndex: 99999,
//           display: "flex",
//           flexDirection: "column",
//           gap: "10px",
//           pointerEvents: "none",
//         }}
//       >
//         {toasts.map((toast) => (
//           <NotificationToast key={toast.id} toast={toast} onClose={onClose} />
//         ))}
//       </div>
//     </>,
//     document.body
//   );
// };
// const NotificationDropdown = () => {
//   const navigate = useNavigate();
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [toasts, setToasts] = useState([]);
//   const toastIdRef = useRef(0);

//   const showToast = (notification) => {
//     const id = ++toastIdRef.current;
//     setToasts((prev) => [...prev, { ...notification, id, isLoginBatch: false }]);
//   };
//   const showUnreadToasts = (unreadNotifications) => {
//     const toShow = unreadNotifications.slice(0, 5); 
//     const batchTotal = unreadNotifications.length; 

//     toShow.forEach((notification, index) => {
//       setTimeout(() => {
//         const id = ++toastIdRef.current;
//         setToasts((prev) => [
//           ...prev,
//           {
//             ...notification,
//             id,
//             isLoginBatch: true,
//             batchIndex: index,
//             batchTotal,
//           },
//         ]);
//       }, index * 600); // 600ms stagger between each toast
//     });
//   };

//   const removeToast = (id) => {
//     setToasts((prev) => prev.filter((t) => t.id !== id));
//   };

//   const fetchNotifications = async () => {
//     try {
//       const response = await ItemService.getNotifications({
//         data: { page: 1, limit: 10 },
//       });
//       if (response?.status === 200) {
//         const data = response?.data || [];
//         setNotifications(data);
//         setUnreadCount(response?.unreadCount || 0);
//         const unread = data.filter((n) => !n.isRead);
//         if (unread.length > 0) {
//           showUnreadToasts(unread);
//         }
//       }
//     } catch (err) {
//       console.log("fetchNotifications err:", err);
//     }
//   };

//   const fetchUnreadCount = async () => {
//     try {
//       const response = await ItemService.getUnreadNotificationCount({ data: {} });
//       if (response?.status === 200) {
//         setUnreadCount(response?.unreadCount || 0);
//       }
//     } catch (err) {
//       console.log("fetchUnreadCount err:", err);
//     }
//   };



//   useEffect(() => {
//     fetchNotifications();
//     fetchUnreadCount();

//     const rawVendorCode =
//       localStorage.getItem("vendorCode") ||
//       sessionStorage.getItem("vendorCode") ||
//       localStorage.getItem("userId") ||
//       sessionStorage.getItem("userId") ||
//       "";

//     const vendorCode = rawVendorCode.toUpperCase();
//     if (vendorCode) {
//       const socket = io(SOCKET_URL, { transports: ["websocket"] });

//       socket.on("connect", () => {
//         socket.emit("joinNotificationRoom", { vendorCode });
//       });

//       socket.on("newnotification", (notification) => {
//         console.log(" New real-time notification:", notification);
//         setNotifications((prev) => [notification, ...prev]);
//         setUnreadCount((prev) => prev + 1);
//         showToast(notification); 
//       });

//       socket.on("disconnect", () => console.log("Socket disconnected"));

//       return () => socket.disconnect();
//     } else {
//       console.warn(" vendorCode not found. Socket room NOT joined.");
//     }
//      // eslint-disable-next-line
//   }, []);


//   const handleViewAll = () => navigate(AP_AUTOConstantsList.VIEWNOTIFI);

//   const handleNotificationClick = async (notificationId) => {
//     const notif = notifications.find((n) => n.notificationId === notificationId);
//     if (notif?.isRead) return; // skip if already read
//     try {
//       const response = await ItemService.markNotificationRead({
//         data: { notificationId },
//       });
//       if (response?.status === 200) {
//         setNotifications((prev) =>
//           prev.map((n) =>
//             n.notificationId === notificationId ? { ...n, isRead: true } : n
//           )
//         );
//         setUnreadCount((prev) => Math.max(0, prev - 1));
//       }
//     } catch (err) {
//       console.log("handleNotificationClick err:", err);
//     }
//   };

//   const handleMarkAllRead = async () => {
//     try {
//       const response = await ItemService.markAllNotificationsRead({ data: {} });
//       if (response?.status === 200) {
//         setNotifications((prev) =>
//           prev.map((n) => ({ ...n, isRead: true }))
//         );
//         setUnreadCount(0);
//       }
//     } catch (err) {
//       console.log("handleMarkAllRead err:", err);
//     }
//   };
//   return (
//     <>
//       <ToastContainer toasts={toasts} onClose={removeToast} />

//       <li className="nav-item dropdown pe-4" title="Notifications">
//         {/* Bell button */}
//         <button
//           className="nav-link nav-icon border-0 bg-transparent"
//           type="button"
//           data-bs-toggle="dropdown"
//           aria-expanded="false"
//           aria-label="Notifications"
//         >
//           <i className="bi bi-bell"></i>
//           {unreadCount > 0 && (
//             <span className="badge bg-primary badge-number">{unreadCount}</span>
//           )}
//         </button>

//         {/* Dropdown */}
//         <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
//           {/* Header */}
//           <li className="dropdown-header d-flex justify-content-between align-items-center">
//             <span>You have {unreadCount} new notifications</span>
//             {unreadCount > 0 && (
//               <button
//                 type="button"
//                 onClick={handleMarkAllRead}
//                 style={{
//                   background: "none",
//                   border: "none",
//                   color: "#0d6efd",
//                   fontSize: "13px",
//                   padding: 0,
//                   marginLeft: "10px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Mark all as read
//               </button>
//             )}
//           </li>

//           <li>
//             <hr className="dropdown-divider" />
//           </li>

//           {/* Notification list */}
//           {notifications.length > 0 ? (
//             notifications.map((notification, index) => (
//               <React.Fragment key={notification.notificationId}>
//                 <li
//                   className={`notification-item ${
//                     notification.isRead ? "" : "unread"
//                   }`}
//                   style={{
//                     cursor: notification.isRead ? "default" : "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                   }}
//                   onClick={() =>
//                     handleNotificationClick(notification.notificationId)
//                   }
//                 >
//                   <i
//                     className={`bi ${notification.icon || "bi-bell"} ${
//                       notification.iconColor || "text-primary"
//                     }`}
//                   ></i>
//                   <div style={{ flex: 1 }}>
//                     <h4>{notification.title}</h4>
//                     <p>{notification.message}</p>
//                     <p style={{ fontSize: "11px", color: "#999", margin: 0 }}>
//                       {notification.createdAt
//                         ? new Date(notification.createdAt).toLocaleString()
//                         : ""}
//                     </p>
//                   </div>
//                   {/* Unread blue dot */}
//                   {!notification.isRead && (
//                     <span
//                       style={{
//                         width: "8px",
//                         height: "8px",
//                         borderRadius: "50%",
//                         background: "#0d6efd",
//                         flexShrink: 0,
//                         marginLeft: "8px",
//                       }}
//                     />
//                   )}
//                 </li>
//                 {index < notifications.length - 1 && (
//                   <li>
//                     <hr className="dropdown-divider" />
//                   </li>
//                 )}
//               </React.Fragment>
//             ))
//           ) : (
//             <li className="dropdown-item text-center text-muted py-3">
//               <i className="bi bi-bell-slash d-block mb-1 fs-5"></i>
//               No new notifications
//             </li>
//           )}

//           <li>
//             <hr className="dropdown-divider" />
//           </li>

//           {/* Footer */}
//           <li className="dropdown-footer">
//             <button
//               type="button"
//               onClick={handleViewAll}
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: "#0d6efd",
//                 fontSize: "14px",
//                 padding: 0,
//                 cursor: "pointer",
//               }}
//             >
//               Show all notifications
//             </button>
//           </li>
//         </ul>
//       </li>
//     </>
//   );
// };

// export default NotificationDropdown;


import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./NotificationDropdown.css";
import AP_AUTOConstantsList from "../../common/AP_AUTOConstants";
import ItemService from "../../services/supplier_appCommonService";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://127.0.0.1:9001";

const NotificationToast = ({ toast, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(toast.id), 5000);
    return () => clearTimeout(timer);
  }, [toast.id, onClose]);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        padding: "14px 16px",
        minWidth: "300px",
        maxWidth: "360px",
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        animation: "toastSlideIn 0.35s ease",
        pointerEvents: "auto",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "#f1f5ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          fontSize: "18px",
        }}
      >
        <i
          className={`bi ${toast.icon || "bi-bell-fill"} ${
            toast.iconColor || "text-primary"
          }`}
        ></i>
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        {toast.isLoginBatch && toast.batchTotal > 1 && (
          <div
            style={{
              fontSize: "10px",
              color: "#fff",
              background: "#0d6efd",
              borderRadius: "4px",
              padding: "1px 6px",
              display: "inline-block",
              marginBottom: "5px",
              fontWeight: 600,
            }}
          >
            {toast.batchIndex + 1} of {toast.batchTotal} unread
          </div>
        )}

        <div
          style={{
            fontWeight: 700,
            fontSize: "13px",
            color: "#1a1a2e",
            marginBottom: "3px",
          }}
        >
          {toast.title}
        </div>

        <div
          style={{
            fontSize: "12px",
            color: "#555",
            marginBottom: "5px",
            wordBreak: "break-word",
          }}
        >
          {toast.message}
        </div>

        <div style={{ fontSize: "11px", color: "#aaa" }}>
          {toast.createdAt
            ? new Date(toast.createdAt).toLocaleTimeString()
            : "Just now"}
        </div>
      </div>

      <button
        onClick={() => onClose(toast.id)}
        style={{
          background: "none",
          border: "none",
          color: "#aaa",
          fontSize: "18px",
          cursor: "pointer",
          padding: 0,
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        <i className="bi bi-x"></i>
      </button>
    </div>
  );
};

const ToastContainer = ({ toasts, onClose }) => {
  if (toasts.length === 0) return null;

  return ReactDOM.createPortal(
    <>
      <style>{`
        @keyframes toastSlideIn {
          from { opacity: 0; transform: translateX(80px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          top: "80px",
          right: "24px",
          zIndex: 99999,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          pointerEvents: "none",
        }}
      >
        {toasts.map((toast) => (
          <NotificationToast key={toast.id} toast={toast} onClose={onClose} />
        ))}
      </div>
    </>,
    document.body
  );
};

const NotificationDropdown = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [toasts, setToasts] = useState([]);
  const toastIdRef = useRef(0);
  const shownUnreadIdsRef = useRef(new Set());

  const showToast = (notification) => {
    const id = ++toastIdRef.current;
    setToasts((prev) => [...prev, { ...notification, id, isLoginBatch: false }]);
  };

  const showUnreadToasts = (unreadNotifications) => {
    const unseen = unreadNotifications.filter(
      (n) => !shownUnreadIdsRef.current.has(n.notificationId)
    );

    const toShow = unseen.slice(0, 5);
    const batchTotal = unseen.length;

    toShow.forEach((notification, index) => {
      shownUnreadIdsRef.current.add(notification.notificationId);

      setTimeout(() => {
        const id = ++toastIdRef.current;
        setToasts((prev) => [
          ...prev,
          {
            ...notification,
            id,
            isLoginBatch: true,
            batchIndex: index,
            batchTotal,
          },
        ]);
      }, index * 600);
    });
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  const fetchNotifications = async () => {
    try {
      const response = await ItemService.getNotifications({
        data: { page: 1, limit: 10 },
      });

      if (response?.status === 200) {
        const data = response?.data || [];
        setNotifications(data);
        setUnreadCount(response?.unreadCount || 0);

        const unread = data.filter((n) => !n.isRead);
        if (unread.length > 0) {
          showUnreadToasts(unread);
        }
      }
    } catch (err) {
      console.log("fetchNotifications err:", err);
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const response = await ItemService.getUnreadNotificationCount({ data: {} });
      if (response?.status === 200) {
        setUnreadCount(response?.unreadCount || 0);
      }
    } catch (err) {
      console.log("fetchUnreadCount err:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();

    const rawVendorCode =
      localStorage.getItem("vendorCode") ||
      sessionStorage.getItem("vendorCode") ||
      localStorage.getItem("userId") ||
      sessionStorage.getItem("userId") ||
      "";

    const vendorCode = rawVendorCode.toUpperCase();

    if (vendorCode) {
      const socket = io(SOCKET_URL, { transports: ["websocket"] });

      socket.on("connect", () => {
        socket.emit("joinNotificationRoom", { vendorCode });
      });

      socket.on("newnotification", (notification) => {
        console.log("New real-time notification:", notification);
        setNotifications((prev) => [notification, ...prev]);
        setUnreadCount((prev) => prev + 1);
        showToast(notification);
      });

      socket.on("disconnect", () => console.log("Socket disconnected"));

      return () => socket.disconnect();
    } else {
      console.warn("vendorCode not found. Socket room NOT joined.");
    }
    // eslint-disable-next-line
  }, []);

  const handleViewAll = () => navigate(AP_AUTOConstantsList.VIEWNOTIFI);

  const handleNotificationClick = async (notificationId) => {
    const notif = notifications.find((n) => n.notificationId === notificationId);
    if (notif?.isRead) return;

    try {
      const response = await ItemService.markNotificationRead({
        data: { notificationId },
      });

      if (response?.status === 200) {
        setNotifications((prev) =>
          prev.map((n) =>
            n.notificationId === notificationId ? { ...n, isRead: true } : n
          )
        );
        setUnreadCount((prev) => Math.max(0, prev - 1));
      }
    } catch (err) {
      console.log("handleNotificationClick err:", err);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      const response = await ItemService.markAllNotificationsRead({ data: {} });

      if (response?.status === 200) {
        setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
        setUnreadCount(0);
      }
    } catch (err) {
      console.log("handleMarkAllRead err:", err);
    }
  };

  return (
    <>
      <ToastContainer toasts={toasts} onClose={removeToast} />

      <li className="nav-item dropdown pe-4" title="Notifications">
        <button
          className="nav-link nav-icon border-0 bg-transparent"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          aria-label="Notifications"
        >
          <i className="bi bi-bell"></i>
          {unreadCount > 0 && (
            <span className="badge bg-primary badge-number">{unreadCount}</span>
          )}
        </button>

        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
          <li className="dropdown-header d-flex justify-content-between align-items-center">
            <span>You have {unreadCount} new notifications</span>
            {unreadCount > 0 && (
              <button
                type="button"
                onClick={handleMarkAllRead}
                style={{
                  background: "none",
                  border: "none",
                  color: "#0d6efd",
                  fontSize: "13px",
                  padding: 0,
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
              >
                Mark all as read
              </button>
            )}
          </li>

          <li>
            <hr className="dropdown-divider" />
          </li>

          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <React.Fragment key={notification.notificationId}>
                <li
                  className={`notification-item ${
                    notification.isRead ? "" : "unread"
                  }`}
                  style={{
                    cursor: notification.isRead ? "default" : "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() =>
                    handleNotificationClick(notification.notificationId)
                  }
                >
                  <i
                    className={`bi ${notification.icon || "bi-bell"} ${
                      notification.iconColor || "text-primary"
                    }`}
                  ></i>

                  <div style={{ flex: 1 }}>
                    <h4>{notification.title}</h4>
                    <p>{notification.message}</p>
                    <p style={{ fontSize: "11px", color: "#999", margin: 0 }}>
                      {notification.createdAt
                        ? new Date(notification.createdAt).toLocaleString()
                        : ""}
                    </p>
                  </div>

                  {!notification.isRead && (
                    <span
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background: "#0d6efd",
                        flexShrink: 0,
                        marginLeft: "8px",
                      }}
                    />
                  )}
                </li>

                {index < notifications.length - 1 && (
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                )}
              </React.Fragment>
            ))
          ) : (
            <li className="dropdown-item text-center text-muted py-3">
              <i className="bi bi-bell-slash d-block mb-1 fs-5"></i>
              No new notifications
            </li>
          )}

          <li>
            <hr className="dropdown-divider" />
          </li>

          <li className="dropdown-footer">
            <button
              type="button"
              onClick={handleViewAll}
              style={{
                background: "none",
                border: "none",
                color: "#0d6efd",
                fontSize: "14px",
                padding: 0,
                cursor: "pointer",
              }}
            >
              Show all notifications
            </button>
          </li>
        </ul>
      </li>
    </>
  );
};

export default NotificationDropdown;